import ClipboardJS from 'clipboard';
import * as NonBlockingTip from 'OK/NonBlockingTip';

interface ClipboardHandler {
    destroy(): void;
}

export class ClipboardUrl {
    protected handler: ClipboardHandler | undefined;

    activate(element: HTMLElement) {
        const text = element.getAttribute('data-clipboard-text');
        const url = element.getAttribute('data-clipboard-url');
        const tipClass = element.getAttribute('data-tip-class')!;
        this.handler = new ClipboardJS(element, {
            text() {
                // Нет отдельного события на факт копирования,
                // поэтому сначала показываем текст, потом копируем адрес в буфер
                if (text) {
                    NonBlockingTip.create({
                        message: text,
                        tipClass: tipClass
                    });
                }
                return url || window.location.href;
            }
        });
    };

    deactivate() {
        this.handler?.destroy();
    };
}
